import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReasonDialog } from './reason-dialog.component';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';



@NgModule({
  declarations: [
    ReasonDialog
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    DialogContainerModule,
  ]
})
export class ReasonDialogModule { }
